module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1#ch1"
    }
  }, [_vm._v("Chapter 1:   The Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2#ch2"
    }
  }, [_vm._v("Chapter 2:   The World of UFOs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3:   The Other Witnesses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:   The Investigation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:   Other New Mexico UFO Reports")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:   Other “Unidentified” Occupant Sightings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:   Psychological Solutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:   UFO Symbols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:   What Symbol Did Zamora See?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Socorro as a Hoax")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Other Landings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Project Blue Book and Socorro")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Physical Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0